import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';

export const CommonLayout_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('../../dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'inventario',
    loadChildren: () =>
      import('../../inventario/inventario.module').then(
        (m) => m.InventarioModule
      ),
    canActivate: [AuthGuard],
    data: { roles: ['ADM', 'VEN','TRA'] },
  },
  {
    path: 'pedido',
    loadChildren: () =>
      import('../../pedidos/pedidos.module').then((m) => m.PedidosModule),
    canActivate: [AuthGuard],
    data: { roles: ['ADM', 'VEN'] },
  },
  {
    path: 'empleado',
    loadChildren: () =>
      import('../../empleado/empleado.module').then((m) => m.EmpleadoModule),
    canActivate: [AuthGuard],
    data: { roles: ['ADM'] },
  },
  {
    path: 'cita',
    loadChildren: () =>
      import('../../citas/citas.module').then((m) => m.CitasModule),
    canActivate: [AuthGuard],
    data: { roles: ['ADM', 'VEN','TRA'] },
  },
  {
    path: 'cliente',
    loadChildren: () =>
      import('../../clientes/clientes.module').then((m) => m.ClientesModule),
    canActivate: [AuthGuard],
    data: { roles: ['ADM', 'VEN'] },
  },
];
